import React from "react";
import { Form } from "react-bootstrap";
import styles from "./MasterData.module.scss";

export type MasterCheckItem = {
  id: string | number;
  label: React.ReactNode;
  checked: boolean;
};

export default function MasterCheckList({
  items,
  emptyLabel,
  onToggle,
}: {
  items: MasterCheckItem[];
  emptyLabel: string;
  onToggle: (id: string | number) => void;
}) {
  return (
    <div className={styles.checkList}>
      {items.length === 0 ? (
        <span>{emptyLabel}</span>
      ) : (
        items.map((item) => (
          <Form.Check
            key={item.id}
            type="checkbox"
            id={`master-check-${item.id}`}
            className={styles.checkItem}
            checked={item.checked}
            onChange={() => onToggle(item.id)}
            label={item.label}
          />
        ))
      )}
    </div>
  );
}
